import * as branchService from '../../../services/branchService'

class validateCreateAccountResult {
  constructor(response) {
    this.isCustomer = response.isCustomer
    this.verificationNeeded = response.verificationNeeded
    this.securityKeyId = response.securityKeyId
    this.branchId = response.branchId
    this.accountNumber = response.accountNumber
    this.contractNumber = response.contractNumber
    this.firstName = response.firstName
    this.lastName = response.lastName
    this.isRegistered = response.isRegistered
    this.token = response.token
    this.namesId = response.namesId
  }

  async setStateOnSuccess(currentStep, app) {
    let branch = await branchService.branchRequest(
      this,
      this.branchId,
      this.token
    )

    if (!this.verificationNeeded) {
      app.setState({
        firstName: this.firstName,
      })
    } else {
      app.setState({
        id: this.securityKeyId,
        message: '',
        currentStep: currentStep,
        branchId: this.branchId,
        branch: branch,
        accountNumber: this.accountNumber,
        contractNumber: this.contractNumber,
        lastName: this.lastName,
        token: this.token,
        namesId: this.namesId,
      })
    }
  }
}

export default validateCreateAccountResult
